import { isJsonString } from '@/utils/isJSONString';

import { AccommodationsSearchRequestDto } from '../AccommodationList/api/requestTypes';
import { FlightsRequest } from '../TransportList/api/requestTypes';
import {ChatResponse} from "@features/Chat/api/useSendChatMessage.ts";

export const parseChatReply = (
  chatResponse: ChatResponse
): [
  string,
  {
    request_type: string;
    preferences: FlightsRequest | AccommodationsSearchRequestDto;
  }
] => {
  const cleanReply = chatResponse.reply;
  
  let json = undefined;
  if(chatResponse.type === 'output' && chatResponse.data && isJsonString(chatResponse.data)) {
    json = JSON.parse(chatResponse.data);
  }
  else if (isJsonString(cleanReply)) {
    json = JSON.parse(cleanReply);
  } else if (cleanReply.indexOf('```json') !== -1) {
    const stringParts = cleanReply.match(/```json(.+)```/is);
    if (stringParts?.[1]) {
      json = JSON.parse(stringParts[1].replaceAll('\n', ''));
    }
  }

  return [cleanReply, json];
};
